// @ts-nocheck
import { Column } from 'react-table'
import { HawalaInfoCell } from './HawalaInfoCell'
import { HawalaActionsCell } from './HawalaActionsCell'
import { HawalaSelectionCell } from './HawalaSelectionCell'
import { HawalaCustomHeader } from './HawalaCustomHeader'
import { HawalaSelectionHeader } from './HawalaSelectionHeader'
import { Hawala } from '../../core/_models'
import dayjs from 'dayjs'

const hawalasColumns: ReadonlyArray<Column<Hawala>> = [
  {
    Header: (props) => <HawalaSelectionHeader tableProps={props} />,
    id: 'selection',
    className: 'min-w-40px',
    Cell: ({ ...props }) => <HawalaSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <HawalaCustomHeader tableProps={props} title="عملیات" className='min-w-80px' />
    ),
    id: 'actions',
    Cell: ({ row }) => (
      <div className="d-flex justify-content-end align-items-center">
        <HawalaActionsCell id={row.original.id} hawala={row.original} />
      </div>
    ),
  },
  {
    Header: (props) => (
      <HawalaCustomHeader tableProps={props} title="شماره حواله" className='min-w-100px' />
    ),
    accessor: 'hawala_number',
  },
  {
    Header: (props) => (
      <HawalaCustomHeader tableProps={props} title="نام فرستنده" className='min-w-120px' />
    ),
    accessor: 'sender_name',
  },
  {
    Header: (props) => (
      <HawalaCustomHeader tableProps={props} title="نام گیرنده" className='min-w-120px' />
    ),
    accessor: 'receiver_name',
  },
  {
    Header: (props) => (
      <HawalaCustomHeader tableProps={props} title="مقدار حواله" className='min-w-100px' />
    ),
    accessor: 'hawala_amount',
    Cell: ({ value }) => <span>{parseFloat(value).toFixed(2)}</span>,
  },
  {
    Header: (props) => (
      <HawalaCustomHeader tableProps={props} title="واحد پول حواله" className='min-w-80px' />
    ),
    accessor: 'hawala_amount_currency_code',
  },
  {
    Header: (props) => (
      <HawalaCustomHeader tableProps={props} title="مقدار پرداختی فروشنده" className='min-w-100px' />
    ),
    accessor: 'converted_amount_taken_from_reseller',
    Cell: ({ value }) => <span>{parseFloat(value).toFixed(2)}</span>,
  },
  {
    Header: (props) => (
      <HawalaCustomHeader tableProps={props} title="ارز فروشنده" className='min-w-100px' />
    ),
    accessor: 'reseller_prefered_currency_code',
  },
  {
    Header: (props) => (
      <HawalaCustomHeader tableProps={props} title="کمیسیون" className='min-w-80px' />
    ),
    accessor: 'commission_amount',
    Cell: ({ value }) => <span>{parseFloat(value).toFixed(2)}</span>,
  },
  {
    Header: (props) => (
      <HawalaCustomHeader tableProps={props} title="یادداشت ادمین" className='min-w-120px' />
    ),
    accessor: 'admin_note',
  },
  {
    Header: (props) => (
      <HawalaCustomHeader tableProps={props} title="نام فروشنده" className='min-w-120px' />
    ),
    accessor: 'reseller.reseller_name',
    Cell: ({ ...props }) => <HawalaInfoCell hawala={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <HawalaCustomHeader tableProps={props} title="وضعیت" className='min-w-100px' />
    ),
    accessor: 'status',
    Cell: ({ value }) => {
      let label = 'نامشخص'
      let className = 'badge badge-secondary'
      switch (value) {
        case 'confirmed':
          label = 'تایید شده'
          className = 'badge badge-success'
          break
        case 'pending':
          label = 'در انتظار'
          className = 'badge badge-warning'
          break
        case 'underprocess':
          label = 'در حال بررسی'
          className = 'badge badge-info'
          break
        case 'rejected':
          label = 'رد شده'
          className = 'badge badge-danger'
          break
        case 'cancelled':
          label = 'لغو شده'
          className = 'badge badge-light'
          break
      }
      return <span className={className}>{label}</span>
    },
  },
  {
    Header: (props) => (
      <HawalaCustomHeader tableProps={props} title="تاریخ ایجاد" className='min-w-160px' />
    ),
    accessor: 'created_at',
    Cell: ({ value }) => <span>{dayjs(value).format('YYYY-MM-DD HH:mm:ss')}</span>,
  },
]

export { hawalasColumns }
